import { useAppMutation } from "../../../../http/useAppMutation.ts";
import { trackEvent } from "../../../../tracking/tracking.ts";
import { useWorkspaceUuid } from "../../../hooks/useWorkspaceUuid.ts";

export const useCreateBoard = ({
  onSuccess,
}: {
  onSuccess?: (uuid: string) => void;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const { mutate, isLoading } = useAppMutation({
    path: `workspaces/${workspaceUuid}/boards`,
    invalidate: [`workspaces/${workspaceUuid}/boards`],
    waitForInvalidation: false,
  }).mutation;

  return {
    createBoard: ({
      name = "",
    }: {
      name?: string;
    } = {}) => {
      mutate(
        { name },
        {
          onSuccess: ({ data }) => {
            onSuccess?.(data.uuid as string);
            trackEvent("project:create", {
              project_uuid: data.uuid,
              project_name: data.name,
            });
          },
        },
      );
    },
    isCreateBoardLoading: isLoading,
  };
};
